import React from 'react';


const PendingResultsPanel = ({
  title,
  pendingText,
  backgroundColor,
  marginTop,
  color,
  showButton,
  buttonText,
  onButtonClick,
  imgSrc,
  maxImgWidth
}) => {

  return (
    <div style={{marginTop: marginTop || "min(6vw, 25px)", padding: "max(3vw, 16px)", backgroundColor: backgroundColor || "#ffffff", boxShadow: "0px 1px 1.5px 0.5px #dddddd", fontSize: "min(6vw, 25px)"}}>
      <div style={{display: "flex", alignItems: "center", justifyContent: "left"}}>
        <div style={{display: "inline-block", fontFamily: "Futura Book", fontSize: "min(5vw, 22px)", lineHeight: "min(5vw, 22px)", color: "#000000"}}>
          {title}
        </div>
      </div>
      <div style={{display: "flex", alignItems: "center", justifyContent: "left", marginTop: "max(1vw, 6px)"}}>
        <div style={{fontFamily: "Futura Light", fontSize: "min(5vw, 22px)", color: color || "#babdc6"}}>
          {`${pendingText}`}
        </div>
      </div>
      {!!(imgSrc) && (
        <div style={{backgroundColor: "#FFFFFF", display: "flex", justifyContent: "center"}}>
          <img style={{width: `100%`, maxWidth: maxImgWidth, margin: "min(2vw, 12px) 0px"}} src={imgSrc} />
        </div>
      )}
      {showButton && (
        <button onClick={() => onButtonClick()} style={{marginTop: "max(2vw, 12px)", border: "none", fontFamily: "Futura Book", fontSize: "min(5vw, 22px)", padding: "6px 8px", width: "100%", color: "#FFFFFF", backgroundColor: "#000000"}}>
          {`${buttonText}`}
        </button>
      )}
    </div>
  )
}

export default PendingResultsPanel